/*
 * Created on Wed Aug 07 2019
 * Created By Rohit
 * Copyright (c) 2019 Buzzlync Inc
 */
import { BASE_URL, loginUrl, SUB_DIRCTORY } from "../../app_config";
import axios from "axios";
import history from "../../history";

let userId;
export const getUserUid = () => {
  const user = localStorage.getItem("user");
  if (!user || !userId || userId === "") {
    alert("user not authenticated");
  }
  if (user) {
    userId = JSON.parse(user).userId;
  }
};

/** call this method upon logout, so upon after db read after subsequent login `userUid` will be initialized again */
export const resetUser = () => {
  localStorage.clear();
};

const requestObj = axios.create({
  baseURL: `${BASE_URL}/`,
  responseType: "json",
  headers: { "content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("jwt_token")}` },
});

const requestObjForImageUpload = axios.create({
  baseURL: `${BASE_URL}/`,
  responseType: "json",
  headers: { "content-Type": "multipart/form-data", Authorization: `Bearer ${localStorage.getItem("jwt_token")}` },
});

// const requestObjForFlorum = axios.create({
//   baseURL: FlarumTokenAPI,
//   responseType: "json",
//   headers: { "content-Type": "application/x-www-form-urlencoded",
//                "Authorization": "Token shoo9aweid5ife4DahlahcahGhah4aet; userId=1",
//             }
// });

const requestObjForFlorum = axios.create({
  baseURL: `${BASE_URL}/api/Consumer/GetAccessToken`,
  responseType: "json",
  headers: { "content-Type": "application/json" },
});

export function postApiCall(apiName, parameters) {
  return requestObj.post(`${apiName}`, parameters).then((res) => {
    if (apiName === loginUrl && res.data.Status) {
      requestObj.defaults.headers.Authorization =
        "Bearer " + res.data.Data.JwtToken;
      requestObjForImageUpload.defaults.headers.Authorization =
        "Bearer " + res.data.Data.JwtToken;
    }
    return res.data;
  }).catch((error) => {
    if (error && error.toString().includes("401")) {
      localStorage.clear();
      history.push({
        pathname: `${SUB_DIRCTORY}/session/signin`,
      });
      return true;
    }
    return error;
  });
}

export function getApiCall(apiName, parameters) {
  return requestObj.get(`${apiName}?${parameters}`).then((res) => {
    return res.data;
  }).catch((error) => {
    if (error && error.toString().includes("401")) {
      localStorage.clear();
      history.push({
        pathname: `${SUB_DIRCTORY}/session/signin`,
      });
      return true;
    }
    return error;
  });
}

export function imageUploadApi(apiName, parameters) {
  return requestObjForImageUpload.post(`${apiName}`, parameters).then((res) => {
    return res.data;
  });
}

export function getFlorumToken(parameters) {
  // return requestObjForFlorum.post('',parameters).then(res => {
  //   return res.data
  // })
  let parms = `username=${parameters.username}&email=${parameters.email}`;
  return requestObjForFlorum.get(`?${parms}`).then((res) => {
    return res.data;
  });
}
